import PropTypes from 'prop-types';

import { VALID_DATE_FORMATS } from '@adsk/alloy-react-datetime';
import { stylePropType } from '@adsk/alloy-react-theme';

import { DATE_PICKER_VARIANTS } from '../consts';

export const datePickerCommonPropTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Variant of the field could be icon or field */
  variant: PropTypes.oneOf(Object.values(DATE_PICKER_VARIANTS)),
  /** Allow selection of dates after minDate, overrides `disablePastDates` */
  minDate: PropTypes.instanceOf(Date),
  /** Allow selection of dates before maxDate, overrides `disableFutureDates` */
  maxDate: PropTypes.instanceOf(Date),
  /** Whether we should disable dates before today */
  disablePastDates: PropTypes.bool,
  /** Whether we should disable dates after today */
  disableFutureDates: PropTypes.bool,
  /** A callback function called when the selected date(s) has been changed */
  onChange: PropTypes.func,
  /** A callback function called when the active months have changed (arrow click, month/year selection) */
  onMonthChange: PropTypes.func,
  /** Handler to manually check if date is selectable */
  isDateSelectable: PropTypes.func,
  /** The format to display the date with */
  format: PropTypes.oneOf(Object.values(VALID_DATE_FORMATS)),
  /** Whether picker should be open initially */
  initialOpen: PropTypes.bool,
  /** Controlled picker open state */
  open: PropTypes.bool,
  /** Whether we should display double date picker */
  double: PropTypes.bool,
  /** Whether the input should display in error state */
  error: PropTypes.bool,
  /** Disable all functionality */
  disabled: PropTypes.bool,
  /** First day of week to display */
  firstDayOfWeek: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6]),
  /** Fill blanks with days from prev/next month. Defaults to true in Weave week-grid mode, false in Alloy. */
  showOutsideDays: PropTypes.bool,
  /** Props passed to DatePickerField or Button (when variant is icon) */
  triggerProps: PropTypes.object,
  /** Props passed to DatePickerOverlay */
  overlayProps: PropTypes.object,
  /** Props passed to each calendar */
  calendarProps: PropTypes.object,
  /** Render custom footer, executed in DatePickerOverlay */
  renderFooter: PropTypes.func,
  /** Render custom footer actions, executed in DatePickerOverlay */
  renderFooterActions: PropTypes.func,
  /** Determines if Day Cell should render an event dot */
  hasEventForDate: PropTypes.func,
  /** Tooltip content for Day Cell */
  tooltipContentForDate: PropTypes.func,
  /** How much years to display under and above current year, defaults to +-20 */
  yearsToDisplay: PropTypes.number,
  /** Specific time zone for this DatePicker, overriding the user's time zone */
  timeZone: PropTypes.string,
  /** Get the container element for the overlay element */
  container: PropTypes.any,
  /** A callback function called when DatePicker overlay is being hidden (closed) */
  onHide: PropTypes.func,
  /** Options that modify how the calendar overlay can shift (see floating-ui documentation https://floating-ui.com/docs/shift) */
  shiftArgs: PropTypes.any,
  /** Options that modify how the calendar overlay can flip (see floating-ui documentation https://floating-ui.com/docs/flip) */
  flipArgs: PropTypes.any,
  /** When true, initialValue will be selected, when false calendar will be opened to initialValue */
  initialValueSelected: PropTypes.bool,
};
